<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div>
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-10">
						<div class="modal-container" @click.stop>
							<div
								class="modal-header row"
								style="justify-content: flex-end;"
							>
								<!-- <div class="col-6">
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                </div> -->
								<div class="col">
									<button
										type="button"
										class="close"
										@click="$emit('closeModal')"
									>
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
							</div>

							<div class="modal-body">
								<h2 class="title">Print Estimasi</h2>

								<div class="row row-space">
									<div class="col-12">
										<div
											class="input-group"
											style="padding-top:0;padding-bottom:0"
										>
											<p class="label">
												Opsi Print Estimasi
											</p>
										</div>

										<div class="input-group">
											<MultiSelect
												:options="options.print"
												v-model="printOption"
												allow-empty="false"
											/>
										</div>
									</div>
								</div>

								<div class="row row-space">
									<div class="col-12">
										<div
											class="input-group"
											style="padding-top:0;padding-bottom:0"
										>
											<p class="label">
												Input Deskripsi Estimasi:
											</p>
										</div>
										<div class="input-group">
											<textarea
												class="form-control"
												rows="5"
												v-model="description"
											>
											</textarea>
										</div>
									</div>
								</div>
								<div class="row mb-3">
									<div class="col-12 text-center">
										<button
											class="btn btn-info mr-3"
											style="width: 75px;"
											@click="printPage"
										>
											Print
										</button>
										<button
											class="btn btn-primary"
											style="width: 75px;"
											@click="$emit('closeModal')"
										>
											Kembali
										</button>
									</div>
								</div>
								<div style="border: 1px solid black">
									<!-- PRINT WO START -->
									<div id="printMe" style="background-color:#fff !important">
										<div style="background-color:#fff">
											<print-header></print-header>

											<hr>

											<div
												class="ml-3 mr-3 mt-3"
												style="background-color:#fff !important"
											>
												<h3 class="ml-3 mr-3">
													Estimasi Biaya Perbaikan
												</h3>

												<div class="row mt-3 pl-3 pr-3 ">
													<div class="col-md-6 col-12 row ">
														<div class="col-5">
														<label style=" font-size: 16px;text-align: left !important;">Nomor Referensi</label>
														</div>
														<div class="col-1">
														<label style=" font-size: 16px;text-align: left !important;">:</label>
														</div>
														<div class="col-6">
														<label style=" font-size: 16px;text-align: left !important;">{{form_code}}</label>
														</div>
													</div>
													<div class="col-md-6 col-12 row ">
														<div class="col-5">
														<label style=" font-size: 16px;text-align: left !important;">Nama Pelanggan</label>
														</div>
														<div class="col-1">
														<label style=" font-size: 16px;text-align: left !important;">:</label>
														</div>
														<div class="col-6">
														<label style=" font-size: 16px;text-align: left !important;">{{woDetail.pelanggan ? woDetail.pelanggan : woDetail.customer ? woDetail.customer.name : '-'}}</label>
														</div>
													</div>
													<div class="col-md-6 col-12 row ">
														<div class="col-5">
														<label style=" font-size: 16px;text-align: left !important;">Tipe Kendaraan</label>
														</div>
														<div class="col-1">
														<label style=" font-size: 16px;text-align: left !important;">:</label>
														</div>
														<div class="col-6">
														<label style=" font-size: 16px;text-align: left !important;">{{woDetail.car_name ? woDetail.car_name : '-'}}</label>
														</div>
													</div>
													<div class="col-md-6 col-12 row ">
														<div class="col-5">
														<label style=" font-size: 16px;text-align: left !important;">Warna / Tahun</label>
														</div>
														<div class="col-1">
														<label style=" font-size: 16px;text-align: left !important;">:</label>
														</div>
														<div class="col-6">
														<label style=" font-size: 16px;text-align: left !important;" v-if="woDetail.car">{{woDetail.car.car_color.name}} / {{woDetail.car.year}}</label>
														<label style=" font-size: 16px;text-align: left !important;" v-else>-</label>
														</div>
													</div>
													<div class="col-md-6 col-12 row ">
														<div class="col-5">
														<label style=" font-size: 16px;text-align: left !important;">Asuransi</label>

														</div>
														<div class="col-1">
														<label style=" font-size: 16px;text-align: left !important;">:</label>
														</div>
														<div class="col-6">
														<label style=" font-size: 16px;text-align: left !important;" >{{insuranceDetails ? insuranceDetails.insuranceCompany.name == 'Umum' ? 'Non Asuransi' : insuranceDetails.insuranceCompany.name : '-'}}</label>
														<!-- <label style=" font-size: 16px;text-align: left !important;" v-else>-</label> -->
														</div>
													</div>
													
													<div class="col-md-6 col-12 row ">
														<div class="col-5">
														<label style=" font-size: 16px;text-align: left !important;">Nomor Polisi</label>
														</div>
														<div class="col-1">
														<label style=" font-size: 16px;text-align: left !important;">:</label>
														</div>
														<div class="col-6">
														<label style=" font-size: 16px;text-align: left !important;">{{woDetail.nomor_polisi ? woDetail.nomor_polisi : '-'}}</label>
														</div>
													</div>
													<div class="col-md-6 col-12 row ">
														<div class="col-5">
														<label style=" font-size: 16px;text-align: left !important;">Nomor SPK</label>
														</div>
														<div class="col-1">
														<label style=" font-size: 16px;text-align: left !important;">:</label>
														</div>
														<div class="col-6">
														<label style=" font-size: 16px;text-align: left !important;">{{data.details.no_spk && data.details.no_spk.toLowerCase() != 'umum' ? data.details.no_spk : '-'}}</label>
														</div>
													</div>
													<div class="col-md-6 col-12 row ">
														<div class="col-5">
															<label style=" font-size: 16px;text-align: left !important;">Alamat</label>
														</div>
														<div class="col-1">
															<label style=" font-size: 16px;text-align: left !important;">:</label>
														</div>
														<div class="col-6">
															<label style=" font-size: 16px;text-align: left !important;">{{woDetail.address ? woDetail.address : woDetail.customer.address ? woDetail.customer.address : '-'}}</label>
														</div>
													</div>
												</div>

												<div class="pl-3 pr-3 mb-3" v-if="estimationPart.length + estimationBahan.length > 0">
													<h4 class="ml-1 mb-3">Part</h4>


													<div class="row mr-1 ml-1" style="background-color : #979797 !important;font-size:14px;padding:0.9em">
														<div class="col-md">
															<th>No</th>
														</div>
														<div class="col-md">
															<th>Sparepart</th>
														</div>
														<div class="col-md">
															<!-- <th>Sparepart</th> -->
														</div>
														
														<div class="col-md">
															<th>Deskripsi</th>
														</div>
														<div class="col-md text-center">
															<b>Qty</b>
														</div>
														<div class="col-md">
															<th>Harga Total</th>
														</div>
													</div>

													<div>
														<div class="row mr-1 ml-1" v-for="(estimation, index) in estimationPart.filter(x => typeof x.is_approved_by_insurance == 'object' || x.is_approved_by_insurance).sort((a, b) => a.sparepart_name.localeCompare(b.sparepart_name))" style="background-color : #f2f4f5 !important;font-size:14px;padding:0.9em">
															<div class="col-md">
																{{ index+1 }}
															</div>
															<div class="col-md">
																{{ estimation.sparepart_name ? estimation.sparepart_name : '-' }}
															</div>
															<div class="col-md"></div>
															
															<div class="col-md">
																{{ estimation.part_number ? estimation.part_number : '-' }}
															</div>
															<div class="col-md text-center">
																{{ numberWithCommas(estimation.amount) }}
															</div>
															<div class="col-md">
																Rp. {{
																	numberWithCommas(
																		estimation.price_per_item
																			? (estimation.price_per_item +
																					(estimation.markup
																						? parseFloat(
																								estimation.markup
																							)
																						: 0)) *
																					estimation.amount
																			: 0
																	)
																}}
															</div>
															
														</div>
														<div class="row mr-1 ml-1" v-if="estimationPart.length == 0" style="background-color : #f2f4f5 !important;font-size:14px;padding:0.9em">
															<div class="col-md">
																-
															</div>
															<div class="col-md">
																-
															</div>
															<div class="col-md">
																<!-- - -->
															</div>
															<div class="col-md">
																-
															</div>
															<div class="col-md">
																-
															</div>
															<div class="col-md">
																X
															</div>
														</div>
														<div class="row  mt-4 p-3 mr-1 ml-1" style="background-color : #f2f4f5 !important;">
															<div class="col-md text-left">
																<label style=" font-size: 16px;text-align: left !important;">Total Harga Part</label>
															</div>
															<div class="col-md text-right pr-4">
																<label style=" font-size: 16px;text-align: right !important;">
																Rp. {{
																	numberWithCommas(
																		data
																			.details
																			.totalPart
																			? parseFloat(
																				data
																					.details
																					.totalPart
																			)
																			: 0
																		+
																		data
																			.details
																			.totalPart
																			? parseFloat(
																				data
																					.details
																					.totalSpecialBahan
																			)
																			: 0
																	)
																}}
																</label>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="ml-3 mr-3 mt-3" v-if="!partOnly">
												<div class="pl-3 pr-3 mb-3">
													<h4 class="ml-1 mb-3">Jasa</h4>


													<div class="row mr-1 ml-1" style="background-color : #979797 !important;font-size:14px;padding:0.9em">
														<div class="col-md">
															<th>No</th>
														</div>
														<div class="col-md">
															<th>Jasa</th>
														</div>
														<div class="col-md">
															<th>Tipe</th>
														</div>
														
														<div class="col-md">
															<th>Deskripsi</th>
														</div>
														<div class="col-md text-center">
															<b>Qty</b>
														</div>
														<div class="col-md">
															<th>Harga Total</th>
														</div>
													</div>

													<div>
														<div class="row mr-1 ml-1" v-for="(estimation, index) in estimationJasa.filter(x => typeof x.is_approved_by_insurance == 'object' || x.is_approved_by_insurance).sort((a, b) => a.sparepart_name.localeCompare(b.sparepart_name))" style="background-color : #f2f4f5 !important;font-size:14px;padding:0.9em">
															<div class="col-md">
																{{ index+1 }}
															</div>
															<div class="col-md">
																{{ estimation.sparepart_name ? estimation.sparepart_name : '-' }}
															</div>
															<div class="col-md">
																{{ estimation.type ? estimation.type : '-' }}
															</div>
															
															<div class="col-md">
																{{ estimation.part_number ? estimation.part_number : '-' }}
															</div>
															<div class="col-md text-center">
																{{ numberWithCommas(estimation.amount) }}
															</div>
															<div class="col-md">
																Rp. {{
																	numberWithCommas(
																		estimation.price_per_item
																			? (estimation.price_per_item +
																					(estimation.markup
																						? parseFloat(
																								estimation.markup
																							)
																						: 0)) *
																					estimation.amount
																			: 0
																	)
																}}
															</div>
															
														</div>
														<div class="row mr-1 ml-1" v-if="estimationJasa.length == 0" style="background-color : #f2f4f5 !important;font-size:14px;padding:0.9em">
															<div class="col-md">
																-
															</div>
															<div class="col-md">
																-
															</div>
															<div class="col-md">
																-
															</div>
															<div class="col-md">
																-
															</div>
															<div class="col-md">
																-
															</div>
															<div class="col-md">
																X
															</div>
														</div>

														<div class="row  mt-4 p-3 mr-1 ml-1" style="background-color : #f2f4f5 !important;">
															<div class="col-md text-left">
																<label style=" font-size: 16px;text-align: left !important;">Total Harga Jasa</label>
															</div>
															<div class="col-md text-right pr-4">
																<label style=" font-size: 16px;text-align: right !important;">
																Rp. {{
																	numberWithCommas(
																		data
																			.details
																			.totalJasa
																			? data
																					.details
																					.totalJasa
																			: 0
																	)
																}}
																</label>
															</div>
														</div>
													</div>
												</div>
											</div>
											<!-- <div class="ml-3 mr-3 mt-3" v-if="!partOnly">
												<div class="pl-3 pr-3 mb-3">
													<h4 class="ml-1 mb-3">Special Bahan</h4>


													<div class="row mr-1 ml-1" style="background-color : #979797 !important;font-size:14px;padding:0.9em">
														<div class="col-md">
															<th>No</th>
														</div>
														<div class="col-md">
															<th>Special Bahan</th>
														</div>
														<div class="col-md">
								
														</div>
														
														<div class="col-md">
															<th>Deskripsi</th>
														</div>
														<div class="col-md text-center">
															<b>Qty</b>
														</div>
														<div class="col-md">
															<th>Harga Total</th>
														</div>
													</div>

													<div>
														<div class="row mr-1 ml-1" v-for="(estimation, index) in estimationBahan.filter(x => typeof x.is_approved_by_insurance == 'object' || x.is_approved_by_insurance)" style="background-color : #f2f4f5 !important;font-size:14px;padding:0.9em">
															<div class="col-md">
																{{ index+1 }}
															</div>
															<div class="col-md">
																{{ estimation.sparepart_name ? estimation.sparepart_name : '-' }}
															</div>
															<div class="col-md">
															</div>
															
															<div class="col-md">
																{{ estimation.part_number ? estimation.part_number : '-' }}
															</div>
															<div class="col-md text-center">
																{{ numberWithCommas(estimation.amount) }}
															</div>
															<div class="col-md">
																Rp. {{
																	numberWithCommas(
																		estimation.price_per_item
																			? (estimation.price_per_item +
																					(estimation.markup
																						? parseFloat(
																								estimation.markup
																							)
																						: 0)) *
																					estimation.amount
																			: 0
																	)
																}}
															</div>
															
														</div>
														<div class="row mr-1 ml-1" v-if="estimationBahan.length == 0" style="background-color : #f2f4f5 !important;font-size:14px;padding:0.9em">
															<div class="col-md">
																-
															</div>
															<div class="col-md">

															</div>
															<div class="col-md">
																-
															</div>
															<div class="col-md">
																-
															</div>
															<div class="col-md">
																-
															</div>
															<div class="col-md">
																X
															</div>
														</div>

														<div class="row  mt-4 p-3 mr-1 ml-1" style="background-color : #f2f4f5 !important;">
															<div class="col-md text-left">
																<label style=" font-size: 16px;text-align: left !important;">Total Harga Special Bahan</label>
															</div>
															<div class="col-md text-right pr-4">
																<label style=" font-size: 16px;text-align: right !important;">
																Rp. {{
																	numberWithCommas(
																		data
																			.details
																			.totalSpecialBahan
																			? data
																					.details
																					.totalSpecialBahan
																			: 0
																	)
																}}
																</label>
															</div>
														</div>
													</div>
												</div>
											</div> -->
											<div class="ml-3 mr-3 mt-3" style="break-inside: avoid;">
												<hr>

												<!-- <div class="row pl-3 pr-3 mb-3">
													<div class="col-2">
														<h5>Note :</h5>
													</div>
													<div class="col-10">
														<h5>{{ description }}</h5>
													</div>
												</div> -->
												<div class="pl-3 pr-3">
													<div class="row mt-2 p-3 mr-1 ml-1" style="background-color : #f2f4f5 !important;">
														<div class="col-md-3 text-left">
															<label style=" font-size: 16px;text-align: left !important;">Note</label>
														</div>
														<div class="col-md-9 text-left pr-4">
															<label style=" font-size: 16px;text-align: right !important;">
															{{description}}
															</label>
														</div>
													</div>
													<div class="row mt-2 p-3 mr-1 ml-1" style="background-color : #f2f4f5 !important;">
														<div class="col-md text-left">
															<label style=" font-size: 16px;text-align: left !important;">Total PPN</label>
														</div>
														<div class="col-md text-right pr-4">
															<label style=" font-size: 16px;text-align: right !important;">
																Rp
																{{
																	numberWithCommas(
																		data.details.ppn
																			? ppn
																			: 0
																	)
																}}
															</label>
														</div>
													</div>
													<div class="row mt-2 p-3 mr-1 ml-1" style="background-color : #f2f4f5 !important;" v-if="printOption == 'Tidak Ada Kondisi'">
														<div class="col-md text-left">
															<label style=" font-size: 16px;text-align: left !important;">Down Payment</label>
														</div>
														<div class="col-md text-right pr-4">
															<label style=" font-size: 16px;text-align: right !important;">
																Rp
																{{
																	this.dp
																		? numberWithCommas(
																				this.dp
																					
																		)
																		: 0
																}}
															</label>
														</div>
													</div>
													<div class="row mt-2 p-3 mr-1 ml-1" style="background-color : #f2f4f5 !important;">
														<div class="col-md text-left">
															<label style=" font-size: 16px;text-align: left !important;">Discount</label>
														</div>
														<div class="col-md text-right pr-4">
															<label style=" font-size: 16px;text-align: right !important;">
																Rp
																{{
																	numberWithCommas(
																		parseFloat(
																			discount
																				? discount
																				: 0
																		) +
																			parseFloat(
																				discount_part
																					? discount_part
																					: 0
																			)
																	)
																}}
															</label>
														</div>
													</div>
													<hr>
													<div class="row mt-2 p-3 mr-1 ml-1" style="background-color : #f2f4f5 !important;">
														<div class="col-md-6 text-left">
															<label style=" font-size: 16px;text-align: left !important;font-weight:bold;">Net Total</label>
														</div>
														<div class="col-md-6 text-right pr-4">
															<label style=" font-size: 16px;text-align: right !important;font-weight:bold;">
																Rp
																{{
																	numberWithCommas(
																		total
																	)
																}}
															</label>
														</div>
														<div class="col-12" style=" font-size: 16px;text-align: right !important;font-weight:bold;"> 
															##
															{{
																Math.round(total)
																	| terbilang
															}}
															Rupiah ##
														</div>
													</div>
												</div>
												

												<div class="row mt-3">
													<div class="col-4 offset-1">
														<h5>Menyetujui,</h5>
														<h5>Nama dan Ttd.</h5>
													</div>
													<div
														class="col-4 offset-2 text-right"
													>
														<h5>
															Jakarta,
															{{
																moment().format(
																	"DD MMMM Y"
																)
															}}
														</h5>
														<h5>Hormat Kami,</h5>
													</div>
													<div class="col-3 offset-1">
														<hr
															style="margin-top:100px"
														/>
													</div>
													<div
														class="col-3 offset-4 text-right"
													>
														<hr
															style="margin-top:100px"
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
									<!-- PRINT WO END -->
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div>
			</div>
		</div>
	</transition>
</template>

<script>
import printHeader from "@/components/print/print_header.vue";
import MultiSelect from "vue-multiselect";
import Terbilang from "terbilang-js";
import moment from "moment";

export default {
	computed() {},
	data() {
		return {
			placeholder: require("@/assets/img/placeholder.png"),
			estimationJasa: [],
			estimationPart: [],
			estimationBahan: [],
			moment: moment,
			description: "",
			ppn: 0,
			total: 0,
			options : {
				print : [
					'Tidak Ada Kondisi',
					'Tanpa DP'
				]
			},
			printOption : 'Tidak Ada Kondisi'
		};
	},
	props: [
		"form_code",
		"data",
		"woDetail",
		"insuranceDetails",
		"discount",
		"discount_part",
		"dp",
		'partOnly'
	],
	components: {
		MultiSelect,
		printHeader,
	},
	async mounted() {
		this.ppn = this.data.details.ppn;
		this.total = this.calculateTotalPrice()
			
		console.log(this.data.details);
		this.splitEstimations();
	},
	watch: {
		printOption : function () {
			this.total = this.calculateTotalPrice()
		}
	},
	methods: {
		calculateTotalPrice () {
			return this.data.details.totalPart +
			this.data.details.totalJasa +
			this.data.details.totalSpecialBahan -
			this.discount -
			this.discount_part +
			this.ppn -
			(this.dp && this.printOption != 'Tanpa DP' ? this.dp : 0);
		},
		// calculatePPN (){
		//   let ppn = parseFloat(this.data.details.ppn ? this.data.details.ppn : 0)
		//   let discount = parseFloat(this.discount ? this.discount : 0) + parseFloat(this.discount_part ? this.discount_part : 0)
		//   // console.log(ppn)

		//   return parseInt(ppn)
		// },
		splitEstimations() {
			let estimationList = this.data.estimations;
			// console.log(estimationList.filter(x => x.sparepart_type == 'J'))
			for (var i = 0; i < estimationList.length; i++) {
				
				if (estimationList[i].deleted_at != null) continue;

				if (estimationList[i].sparepart_type == "J")
					this.estimationJasa.push(estimationList[i]);
				else
					this.estimationPart.push(estimationList[i]);
			}
		},
		printPage() {
			if (this.description == "") {
				this.$store.dispatch("triggerAlert", [
					false,
					"Mohon Di-isi Deskripsi Estimasi!",
				]);
				return;
			}

			let styles = {
				name: '_blank',
				specs: [
					'fullscreen=yes',
					'titlebar=yes',
					'scrollbars=yes'
				],
				styles : [
					'https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css',
					'https://unpkg.com/kidlat-css/css/kidlat.css',
					'/custom.css'
				]
			}

			this.$htmlToPaper("printMe" , styles , () => {
				console.log('done')
			});
			/* 

				
			*/
		},
		evaluateDamage(figure) {
			var damages = "";
			for (var i in figure) {
				for (var j in figure[i]) {
					if (figure[i][j])
						damages += `${this.toCapitalizedWords(j)}, `;
				}
			}

			return damages ? damages.substring(0, damages.length - 2) : "-";
		},
	},
};
</script>

<style scoped>
td {
	font-size: 12px;
}


/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
	outline: none;
	margin: 0;
	border: none;
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
	width: 100%;
	font-size: 14px;
	font-family: inherit;
}

.input--style-4 {
	line-height: 50px;
	background: #fafafa;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;
	padding: 0 20px;
	font-size: 16px;
	color: #666;
	-webkit-transition: all 0.4s ease;
	-o-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
	/* WebKit, Blink, Edge */
	color: #666;
}

.input--style-4:-moz-placeholder {
	/* Mozilla Firefox 4 to 18 */
	color: #666;
	opacity: 1;
}

.input--style-4::-moz-placeholder {
	/* Mozilla Firefox 19+ */
	color: #666;
	opacity: 1;
}

.input--style-4:-ms-input-placeholder {
	/* Internet Explorer 10-11 */
	color: #666;
}

.input--style-4:-ms-input-placeholder {
	/* Microsoft Edge */
	color: #666;
}

.label {
	font-size: 14px;
	color: #555;
	text-transform: capitalize;
	display: block;
	margin-bottom: 5px;
}

.radio-container {
	display: inline-block;
	position: relative;
	padding-left: 30px;
	cursor: pointer;
	font-size: 16px;
	color: #666;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.radio-container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
	background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
	display: block;
}

.radio-container .checkmark:after {
	top: 50%;
	left: 50%;
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	-o-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	width: 12px;
	height: 12px;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	background: #57b846;
}

.checkmark {
	position: absolute;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	left: 0;
	height: 20px;
	width: 20px;
	background-color: #e5e5e5;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

.input-group {
	position: relative;
	/* margin-bottom: 22px; */
	padding: 20px;
}

.input-group-icon {
	position: relative;
}

.input-icon {
	position: absolute;
	font-size: 18px;
	color: #999;
	right: 18px;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
	font-size: 40px;
	color: #525252;
	margin-bottom: 40px;
	text-align: center;
}

.companyDetails {
	margin-bottom: 5px;
	font-size: 0.6rem;
}
/* .documentTitle{
  font-size: 40px;
  border: 1px solid black;
  border-radius: 10px;
  padding:20px 30px;
} */
.contentTitle {
	margin-top: 8px;
	font-size: 14px;
	font-weight: 700;
}
.contentVariable {
	display: flex;
	flex-direction: column;
	justify-content: center;
	font-size: 14px;
}
</style>
